//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeSubradaCiselAkci.ts						</Name>
//    <Description> Dialog seznam �ady ��sel akc�										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-21                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvsdde) GID:(Web.Set.Ts) V1:(rok,ico,ixs_pla,subrada,nazev,maska,aktivita,dat_zmena,zmenu_prov,cislo_od,cislo_do) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamAdeSubradaCiselAkci extends GContentBase<SeznamAdeSubradaCiselAkciDesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
		private init() {
			this.createMenuBar();
            SeznamAdeSubradaCiselAkciDesigner.SeznamAdeSubradaCiselAkciDesignerInit(this, this.rok,this.ico,this.ixs_pla,this.subrada );
			this.setTitle();
            this.createGrid();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
                this.title = "jres:29807911" 	//RC 29807911 : �ady ��sel akc�
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			return this.actions.createBar(["actDetail"]);
		}

		/**
		 * vytvo�it menu
		 */
		private createMenuBar(): void {
			this.actions.addRange({
				actNovy: {
					icon: "gi-plus",
					caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
					run: () => {
						var newRecord = true;
						this.openDetail(newRecord);
					}
				},
				actDetail: {
					icon: "gi-detail",
					caption: "jres:32131033",
					run: () => {
						this.openDetail();
					}
				},
				actReload: {
					icon: "gi-refresh",
					caption: "jres:33000084", //RC 33000084 : Obnovit
					run: () => {
						this.beginOperation()
						SeznamAdeSubradaCiselAkciDesigner.LoadData(this, this.rok, this.ico, this.ixs_pla, this.subrada);
						this.grid.ggrid("setData", this.view);
						this.endOperation();
					}
				}
			})
			this.menuBar(this.actions.createBar(["actReload*", "actNovy*", "actDetail*"]));
		}

		//#endregion

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {
            var newRecord = _new == null ? false : _new;
            if (newRecord === true) 
                // nov� z�znam p�i pr�zdn�m gridu
                Dialogs.DetailAdeSubradaCiselAkciDlg(this, { rok: this.rok,ico: this.ico,ixs_pla: this.ixs_pla,subrada: this.subrada, grid: this.grid, newRecord: newRecord }).done((data: any) => {     });
             
			else if (Utils.isGridEmpty(this.grid))
				SeznamBase.createWarningNot(this, { title: "jres:29807911", text: "jres:32131036", id: "id-flash-select-more-rows-grid-detail" })
            else {
				var selection = this.grid.ggrid("getSelection");
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailAdeSubradaCiselAkciDlg(this, { rok: data.rok,ico: data.ico,ixs_pla: data.ixs_pla,subrada: data.subrada, grid: this.grid, newRecord: newRecord }).done((data: any) => {         });
                }
				else {
					SeznamBase.createWarningNot(this, { title: "jres:29807911", text: "jres:32131037", id: "id-flash-select-more-rows-grid-detail" })
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {
            this.grid = $("<div>").gautofit().appendTo(this.element);
			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "rok,ico,ixs_pla,subrada",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: this.actions.actDetail,
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "rok,ico,ixs_pla,subrada",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.actions.actDetail?.update({ enabled: obj.count == 1 })
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {
			var panel: JQuery<HTMLElement> | undefined;
			if (this.closed) 		// o�et�en� zav�en� contentu
				return;
			if (this.sidebar !== undefined) 
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			else 
				panel = elementPanel;
			if (panel !== undefined) {
				if (this.panelElement !== undefined) 
					this.panelElement.remove();
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

	}

}
